import { render, staticRenderFns } from "./TimeLineEvents.vue?vue&type=template&id=5f55e61d&"
import script from "./TimeLineEvents.vue?vue&type=script&lang=js&"
export * from "./TimeLineEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTimeline});
